<template>
  <AppearanceFloating
    :visible="isVisible"
    :title="$t('software_theme')"
    :auto-saved-text="$t('software_theme_auto_saved')"
    :reset-text="$t('software_theme_reset')"
    transition-name="theme-studio-slide"
    :z-index="210"
    :is-overlay="isSelectorView"
    default-width="min(720px, calc(100vw - var(--sidebar-width-v5) - var(--sidebar-right-width-v5) - 108px))"
    default-max-height="calc(100vh - 132px)"
    overlay-width="min(860px, calc(100vw - 56px))"
    overlay-max-height="calc(100vh - 56px)"
    @close="closeSoftwareThemePanel"
    @reset="resetSoftwareTheme"
  >
    <setting_software_theme :show-preview="isSelectorView" />
  </AppearanceFloating>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppearanceFloating from './AppearanceFloating.vue'
import setting_software_theme from './setting_software_theme.vue'
import { closeSoftwareThemePanel, resetSoftwareTheme, softwareThemePanelVisible } from '@/service/software_theme'
import { DeviceManager } from '@/service/device'
import { DevicePid } from '@/define/define'

const isVisible = computed(() => softwareThemePanelVisible.value)
const isSelectorView = computed(() => DeviceManager.instance.state.currentPid === DevicePid.None)
</script>
